export default __webpack_public_path__ + "static/media/IMG_1543.264202bf.jpg";